import React, { useState } from 'react';
import { Row, Col, Button, Card, Alert } from 'react-bootstrap';
import { FaUpload, FaFileAlt, FaTrash, FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const ApplicationDocumentUploadForm = ({ isActive, documents, setDocuments, customerInfo, handlePrev, handleNext }) => {
    const [uploadError, setUploadError] = useState('');

    const documentCategories = [
        { value: 'nufus_cuzdani', label: 'Nüfus Cüzdanı' },
        { value: 'ehliyet', label: 'Ehliyet' },
        { value: 'gelir_belgesi', label: 'Gelir Belgesi' },
        { value: 'ikametgah_belgesi', label: 'İkametgah Belgesi' },
        { value: 'banka_hesap_belgesi', label: 'Banka Hesap Belgesi' },
        { value: 'maas_bordrosu', label: 'Maaş Bordrosu' },
        { value: 'diger', label: 'Diğer' }
    ];

    const handleFileSelect = (file, category) => {
        setUploadError('');

        // Dosya validasyonu
        const maxSize = 10 * 1024 * 1024; // 10MB
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];

        if (file.size > maxSize) {
            setUploadError('Dosya boyutu 10MB\'dan büyük olamaz');
            return;
        }

        if (!allowedTypes.includes(file.type)) {
            setUploadError('Sadece PDF, JPG ve PNG dosyaları yüklenebilir');
            return;
        }

        // Aynı kategoride mevcut dosya varsa çıkar
        const filtered = documents.filter(doc => doc.category !== category);

        // Yeni dosyayı ekle (File objesi olarak - henüz upload YOK)
        const newDoc = {
            id: `${category}_${Date.now()}`,
            file: file,
            category: category,
            originalName: file.name,
            size: file.size
        };

        setDocuments([...filtered, newDoc]);
    };

    const handleRemoveDocument = (docId) => {
        setDocuments(prev => prev.filter(doc => doc.id !== docId));
    };

    if (!isActive) return null;

    return (
        <div>
            <h4 className="mb-4">Belge Yükleme (Opsiyonel)</h4>
            <p className="text-muted mb-4">
                Başvurunuzu hızlandırmak için gerekli belgelerinizi önceden yükleyebilirsiniz.
            </p>

            {uploadError && (
                <Alert variant="danger">{uploadError}</Alert>
            )}

            <Row>
                {documentCategories.map(category => (
                    <Col md={6} key={category.value} className="mb-3">
                        <Card>
                            <Card.Body>
                                <h6>{category.label}</h6>

                                {/* Upload Input */}
                                <input
                                    type="file"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    onChange={(e) => {
                                        if (e.target.files[0]) {
                                            handleFileSelect(e.target.files[0], category.value);
                                        }
                                    }}
                                    style={{ display: 'none' }}
                                    id={`upload-${category.value}`}
                                />

                                <label
                                    htmlFor={`upload-${category.value}`}
                                    className="btn btn-outline-primary btn-sm w-100 mb-2"
                                    style={{ cursor: 'pointer' }}
                                >
                                    <FaUpload className="me-1" />
                                    Dosya Seç
                                </label>

                                {/* Selected Documents */}
                                {documents
                                    .filter(doc => doc.category === category.value)
                                    .map(doc => (
                                        <div key={doc.id} className="d-flex justify-content-between align-items-center bg-light p-2 rounded">
                                            <div>
                                                <FaFileAlt className="me-1" />
                                                <small>{doc.originalName}</small>
                                            </div>
                                            <Button
                                                variant="outline-danger"
                                                size="sm"
                                                onClick={() => handleRemoveDocument(doc.id)}
                                            >
                                                <FaTrash />
                                            </Button>
                                        </div>
                                    ))
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* Navigation Buttons */}
            <div className="d-flex justify-content-between mt-4">
                <Button variant="outline-secondary" onClick={handlePrev}>
                    <FaArrowLeft className="me-2" />
                    Önceki Adım
                </Button>
                <Button variant="primary" onClick={handleNext}>
                    Sonraki Adım
                    <FaArrowRight className="ms-2" />
                </Button>
            </div>
        </div>
    );
};

export default ApplicationDocumentUploadForm;